<div style="grid-template-rows: 1fr auto" class="vertical-menu bg-body">
  <ngx-simplebar #componentRef>
    <div class="sidebar_grid">
      <!-- Profile / Logo Section -->
      <div class="profile py-4 d-flex align-items-center justify-content-center gap-2 position-relative">
        <a class="navbar-brand text-center" routerLink="/academies">
          @if (!isCondensed) {
          <span id="logo" class="d-none d-md-inline">
            <img [src]="logo" class="academy-menu-logo" alt="Vult logo" />
          </span>
          }
          @if (isCondensed) {
          <span id="logo" class="d-none d-md-inline">
            <img [src]="logo" class="academy-menu-logo academy-menu-logo-sm" alt="Vult logo" />
          </span>
          }
          <span id="logo" class="d-md-none">
            <img [src]="logo" class="academy-menu-logo academy-menu-logo-mobile" alt="Vult logo" />
          </span>
        </a>

        <div class="position-absolute d-lg-none top-0 end-0 m-3">
          <span class="bx bx-x pointer fs-1_6rem" (click)="onToggleMobileMenu()"></span>
        </div>
      </div>

      <!-- Quick search -->
      <div class="px-3 pb-2">
        <button type="button" class="quick-jump-trigger" (click)="openQuickJump()" [attr.aria-label]="'SUPER_ADMIN.QUICK_JUMP.OPEN' | translate">
          <span class="isax isax-search-normal-1"></span>
          @if (!isCondensed) {
            <span class="flex-grow-1 text-start">{{ 'SUPER_ADMIN.QUICK_JUMP.OPEN' | translate }}</span>
            <kbd>Ctrl K</kbd>
          }
        </button>
      </div>

      <!-- Sidebar Menu -->
      <div id="sidebar-menu">
        <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
          @for (item of menuItems; track item) {
          @if (item.isTitle) {
          <li class="menu-title section-title">
            <button type="button" class="section-toggle" (click)="toggleSection(item.label)" [attr.aria-expanded]="!isSectionCollapsed(item.label)">
              <span>{{ item.label || '' | translate }}</span>
              <span class="bx bx-chevron-down section-chevron" [class.collapsed]="isSectionCollapsed(item.label)"></span>
            </button>
          </li>
          } @else if (!isSectionCollapsed(item.section)) {
          <li (click)="clickElWhenCollapsed()">
            @if (item.subItems && item.subItems.length > 0) {
            <a href="javascript:void(0);" class="is-parent has-arrow">
              @if (item.icon) {
              <i style="width: 20px" class="text-center me-1 {{ item.icon }}"></i>
              }
              <span>{{ item.label || '' | translate }}</span>
              @if (badgeCount(item) > 0) {
              <span class="nav-badge">{{ badgeCount(item) }}</span>
              }
            </a>

            <ul class="sub-menu" aria-expanded="false">
              @for (subitem of item.subItems; track subitem) {
              <li>
                <a [routerLink]="subitem.link" class="side-nav-link-ref" routerLinkActive="active">
                  @if (subitem.icon) {
                  <i style="width: 16px" class="text-center me-1 {{ subitem.icon }}"></i>
                  }
                  <span>{{ subitem.label || '' | translate }}</span>
                </a>
              </li>
              }
            </ul>
            } @else {
            <a [routerLink]="item.link" class="side-nav-link-ref" routerLinkActive="active">
              @if (item.icon) {
              <i style="width: 20px" class="text-center me-1 {{ item.icon }}"></i>
              }
              <span>{{ item.label || '' | translate }}</span>
              @if (badgeCount(item) > 0) {
              <span class="nav-badge" [class.nav-badge-warn]="item.badge === 'renewals'">{{ badgeCount(item) }}</span>
              }
            </a>
            }
          </li>
          }
          }
        </ul>
      </div>
    </div>
  </ngx-simplebar>
</div>